import { toggleableStateKeptInSessionStorageFactory } from './toggleable-state-kept-in-session-storage-factory';

/**
 * The e2e suite's mark on the browser's user agent. The suite appends it to Chrome's own user agent
 * rather than sending it alone, because third-party scripts read the browser version from the user
 * agent: Apple Pay's button hides itself when it can't find one.
 */
export const END_TO_END_TEST_RUN_USER_AGENT_MARKER = 'e2e tests suite';

export class End2EndTestRunState
	extends toggleableStateKeptInSessionStorageFactory('e2e-test-run') {

	static isTestRunUserAgent(userAgent: string): boolean {
		return userAgent.includes(END_TO_END_TEST_RUN_USER_AGENT_MARKER);
	}

}
